import {NativeLocationInterface} from './NativeLocationInterface';

export const nativeLocationModule: NativeLocationInterface = {
  initialize: () => Promise.resolve(),
  uninitialize: () => {},
  isPermissionGranted: () => Promise.resolve(false),
  getLastLocation: () => null,
  isReportingAllowed: () => false
};
